module.exports = __webpack_public_path__ + "static/media/chevron-on.27846ac3.svg";